import { eBranches } from "sb-helpers";
import { Scoreboards } from "../../constants";
export var mapGamePart = function (x) {
    x.gamePart = x.liveGameState && x.liveGameState.gamePart && !Scoreboards[eBranches[x.sportId]]
        ? x.liveGameState.gamePart : "";
    return x;
};
//# sourceMappingURL=mapGamePart.js.map